(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-protocols"]) return;
  try {
    
function initProtocolHub(root) {
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const grid = root.querySelector('[data-grid]'), cards = [...grid.querySelectorAll('[data-card]')], buttons = [...root.querySelectorAll('[data-goal]')], search = root.querySelector('[data-search]'), sort = root.querySelector('[data-sort]'), count = root.querySelector('[data-count]');
  let goal = 'all';
  const update = () => {
    const term = search.value.trim().toLocaleLowerCase(); let visible = 0;
    cards.forEach(card => { card.hidden = !((goal === 'all' || card.dataset.category === goal) && card.dataset.searchText.includes(term)); if (!card.hidden) visible++; });
    count.textContent = visible === 1 ? count.dataset.one : count.dataset.template.replace('__COUNT__', visible);
    root.querySelector('[data-empty]').hidden = visible > 0;
    cards.sort((a, b) => sort.value === 'az' ? a.dataset.title.localeCompare(b.dataset.title) : Number(a.dataset.position) - Number(b.dataset.position));
    cards.forEach(card => grid.append(card));
  };
  buttons.forEach(button => button.addEventListener('click', () => { goal = button.dataset.goal; buttons.forEach(b => b.setAttribute('aria-pressed', b === button ? 'true' : 'false')); update(); }));
  search.addEventListener('input', update); sort.addEventListener('change', update);
  root.querySelector('[data-reset]').addEventListener('click', () => { search.value = ''; buttons[0].click(); search.focus(); });
}
document.querySelectorAll('.aph').forEach(initProtocolHub);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.aph').forEach(initProtocolHub));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function initializeApothecaFooter() {
    document.querySelectorAll('[data-apotheca-footer]').forEach(function (footer) {
      if (footer.dataset.initialized) return;
      footer.dataset.initialized = 'true';
      var desktop = window.matchMedia('(min-width: 1000px)');
      var groups = footer.querySelectorAll('[data-footer-group]');
      function syncGroups() { groups.forEach(function (group) { group.open = desktop.matches; }); }
      syncGroups();
      desktop.addEventListener('change', syncGroups);
      footer.addEventListener('click', function (event) {
        if (desktop.matches && event.target.closest('[data-footer-group] > summary')) event.preventDefault();
      });
    });
  }
  initializeApothecaFooter();
  document.addEventListener('shopify:section:load', initializeApothecaFooter);

  } catch(e) { console.error(e); }
})();
})();
